export default {
  defaultDisplayName: 'Neues virtuelles Signal',
};
